export default __webpack_public_path__ + "static/media/List-documentation.a25d79d9.md";